export const arrayMenuLavanderia = [
  {
    id: 1,
    key: 'maestro',
    name: 'Maestro',
    vista: '#MAESTRO',
    arraySubItem: [
      {
        id: 1,
        title: 'Puntos de lavandería',
        submenu: 'point',
        showPanel: false,
        vista: '#PUNTOS DE LAVANDERIA',
        content: {
          headerPanel: 'table-point',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 2,
        title: 'Equipos de lavandería',
        submenu: 'equipment',
        showPanel: false,
        vista: '#EQUIPOS DE LAVANDERIA',
        content: {
          headerPanel: 'table-equipment',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Proveedores',
        submenu: 'supplier',
        showPanel: false,
        vista: '#PROVEEDORES',
        content: {
          headerPanel: 'table-supplier',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 4,
        title: 'Servicios',
        submenu: 'service',
        showPanel: false,
        vista: '#SERVICIOS',
        content: {
          headerPanel: 'table-service',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 5,
        title: 'Configuración de Días',
        submenu: 'configuration-hours',
        showPanel: false,
        vista: '#CONFIGURACION DE DIAS',
        content: {
          headerPanel: 'table-configuration-hours',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 6,
        title: 'Configuración de Días de Lavado',
        submenu: 'configuration-days-laundry',
        showPanel: false,
        vista: '#CONFIGURACION DE DIAS DE LAVADO',
        content: {
          headerPanel: 'table-configuration-days-laundry',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 7,
        title: 'Gestión de Correlativos',
        submenu: 'management-sequential',
        showPanel: false,
        vista: '#GESTION DE CORRELATIVOS',
        content: {
          headerPanel: 'table-management-sequential',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 2,
    key: 'gestion-lavado-ropa',
    name: 'Gestión de Lavado de Ropa',
    vista: '#GESTION DE LAVADO DE ROPA',
    arraySubItem: [
      {
        id: 1,
        title: 'Orden de Lavado Ropa de huéspedes',
        submenu: 'laundry',
        showPanel: false,
        vista: '#ORDEN DE LAVADO ROPA DE HUESPEDES',
        content: {
          headerPanel: 'table-laundry',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 2,
        title: 'Orden de Lavado Ropa Cama y otros',
        submenu: 'operation',
        showPanel: false,
        vista: '#ORDEN DE LAVADO ROPA DE OPERACION',
        content: {
          headerPanel: 'table-operation',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Generar Orden de lavado por lote',
        submenu: 'generate-batch',
        showPanel: false,
        vista: '#GENERAR ORDEN DE LAVADO POR LOTE',
        content: {
          headerPanel: 'table-generate-batch',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 4,
        title: 'Órdenes de lavado por lote',
        submenu: 'batch',
        showPanel: false,
        vista: '#ORDEN DE LAVADO POR LOTE',
        content: {
          headerPanel: 'table-batch',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 5,
        title: 'Recepción Masiva de Ropa',
        submenu: 'reception',
        showPanel: false,
        vista: '#RECEPCION MASIVA DE ROPA',
        content: {
          headerPanel: 'table-reception',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 6,
        title: 'Salida Masiva de Ropa',
        submenu: 'out',
        showPanel: false,
        vista: '#SALIDA MASIVA DE ROPA',
        content: {
          headerPanel: 'table-out',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 3,
    key: 'vdi',
    name: 'Visualización de Información',
    vista: '#VISUALIZACION DE INFORMACION',
    arraySubItem: [
      {
        id: 2,
        title: 'Check in del día',
        vista: '#CHECK IN DEL DIA',
        submenu: 'checkInList',
        path: '/hoteleria',
        showPanel: false,
        content: {
          headerPanel: 'table-checkIn-list',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
        fromOtherApp: true,
      },
      {
        id: 3,
        title: 'Check out del día',
        submenu: 'checkOutList',
        vista: '#CHECK OUT DEL DIA',
        path: '/hoteleria',
        showPanel: false,
        content: {
          headerPanel: 'table-checkOut-list',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
        fromOtherApp: true,
      },
      {
        id: 4,
        title: 'Huéspedes',
        submenu: 'guestList',
        vista: '#HUESPEDES',
        path: '/hoteleria',
        showPanel: false,
        content: {
          headerPanel: 'header-guest-list',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
        fromOtherApp: true,
      },
      {
        id: 5,
        title: 'Registro de requerimientos, quejas y/o reclamos',
        vista: '#REGISTRO DE REQUERIMIENTOS, QUEJAS Y/O RECLAMOS',
        submenu: 'claim',
        path: '/central',
        showPanel: false,
        content: {
          headerPanel: 'table-claim',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
        fromOtherApp: true,
      },
    ],
  },
  {
    id: 4,
    key: 'rep',
    name: 'Reporte',
    vista: '#REPORTE',
    arraySubItem: [
      {
        id: 1,
        title: 'Frecuencia de Lavado',
        vista: '#FRECUENCIA DE LAVADO',
        submenu: 'reportFrecuency',
        showPanel: false,
        content: {
          headerPanel: 'table-report-laundry-frecuency',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 2,
        title: 'Tiempo de Lavado',
        submenu: 'reportTime',
        vista: '#TIEMPO DE LAVADO',
        showPanel: false,
        content: {
          headerPanel: 'table-report-laundry-time',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Generar Reporte de Facturación',
        submenu: 'generateReportBilling',
        vista: '#GENERAR REPORTE DE FACTURACION',
        showPanel: false,
        content: {
          headerPanel: 'table-generate-report-laundry-billing',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 4,
        title: 'Reporte de Facturación',
        submenu: 'reportBilling',
        vista: '#REPORTE DE FACTURACION',
        showPanel: false,
        content: {
          headerPanel: 'table-report-laundry-billing',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 5,
        title: 'Reporte de Inspección y Observación',
        submenu: 'reportBilling',
        vista: '#REPORTE DE INSPECCION Y OBSERVACION',
        showPanel: false,
        content: {
          headerPanel: 'table-report-inspection-observation',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 6,
        title: 'Reporte de Facturación de Lavanderia',
        submenu: 'reportBilling',
        vista: '#REPORTE FACTURACION LAVANDERIA',
        showPanel: false,
        content: {
          headerPanel: 'table-report-billing-laundry',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 7,
        title: 'Reporte de Valoración',
        showPanel: false,
        vista: '#REPORTE DE VALORACION',
        content: {
          headerPanel: 'table-report-valoration',
        },
        closable: true,
        submenu: 'report-valoration',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 5,
    key: 'gestion-de-servicio',
    name: 'Gestión de Servicio',
    vista: '#GESTION DE SERVICIO',
    arraySubItem: [
      {
        id: 1,
        title: 'Mantenimiento de Inspecciones de Lavandería',
        submenu: 'inspect',
        showPanel: false,
        vista: '#MANTENIMIENTO DE INSPECCIONES DE LAVANDERIA',
        content: {
          headerPanel: 'table-inspect',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 6,
    key: 'app-order',
    name: 'App Huesped',
    vista: '#APP HUESPED',
    arraySubItem: [
      {
        id: 2,
        title: 'Orden de Lavado',
        showPanel: false,
        vista: '#ORDEN DE LAVADO',
        content: {
          headerPanel: 'table-laundry-app',
        },
        closable: true,
        submenu: 'app-order-laundry',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 7,
    key: 'delivery-clothes',
    name: 'Entrega de Ropa',
    vista: '#ENTREGA DE ROPA',
    arraySubItem: [
      {
        id: 2,
        title: 'Ropa cama',
        showPanel: false,
        vista: '#ENTREGA DE ROPA CAMA',
        content: {
          headerPanel: 'header-delivery-clothes-bed',
        },
        closable: true,
        submenu: 'delivery-clothes-bed',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
]
